import React, { useState, InputHTMLAttributes } from 'react'
import { CloseCircleFilled } from '@ant-design/icons'
import styles from './index.module.less'

interface InputProps extends InputHTMLAttributes<any> {
  addonBefore?: any
  error?: any
  className?: string
  addonAfter?: React.ReactNode | null | undefined
  placeholder?: string
  onChange?: (e: any) => void
  trim?: boolean
}

export default function Index({
  addonBefore,
  onChange = e => {},
  onBlur = e => {},
  trim,
  ...props
}: InputProps) {
  const [inputValue, setInputValue] = useState<any>('')

  // 输入改变
  const change = value => {
    setInputValue(value)
    onChange(value)
  }

  // 清空
  const clear = () => {
    setInputValue('')
    onChange('')
  }

  return (
    <div className={styles.box}>
      <input
        value={inputValue}
        className={styles.input}
        {...props}
        onChange={e => change(e.target.value)}
        onBlur={e => {
          // 去掉前后空格
          let value = trim ? e.target.value.trim() : e.target.value
          let enent = { target: { value } } as any
          onChange(enent)
          onBlur(enent)
        }}
      />
      {inputValue && (
        <span className={styles.iconBox} onClick={clear}>
          <CloseCircleFilled className={styles.icon} />
        </span>
      )}
    </div>
  )
}
